import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'img[imgLoaded]',
  exportAs: 'imgLoaded'
})
export class ImgLoadedDirective {
  loaded = false;

  @Output() imgLoaded = new EventEmitter();

  @HostListener('load')
  onLoad() {
    this.loaded = true;
    this.imgLoaded.emit(this.loaded);
  }

  constructor(private elRef: ElementRef<HTMLImageElement>) {
    if (this.elRef.nativeElement.complete) {
      this.onLoad();
    }
  }
}
